import GeneralProduct from '~/Api/Product/Product';

import ReferencePrice from './ReferencePrice';

export default class Product {
	allowsEmptyCalculator: { exFactory: boolean };

	packageSizeForCalculation: number | null;

	packageSizeForSingleUnit: number | null;

	product: GeneralProduct;

	referenceDataSource: boolean;

	referencePrices: ReferencePrice[];

	selectable: boolean;

	selected: boolean;

	singleUnitPackageSize: boolean;

	constructor(
		allowsEmptyCalculator: { exFactory: boolean },
		packageSizeForCalculation: number | null,
		packageSizeForSingleUnit: number | null,
		product: GeneralProduct,
		referenceDataSource: boolean,
		referencePrices: ReferencePrice[],
		selectable: boolean,
		selected: boolean,
		singleUnitPackageSize: boolean
	) {
		this.allowsEmptyCalculator = allowsEmptyCalculator;
		this.packageSizeForCalculation = packageSizeForCalculation;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
		this.product = product;
		this.referenceDataSource = referenceDataSource;
		this.referencePrices = referencePrices;
		this.selectable = selectable;
		this.selected = selected;
		this.singleUnitPackageSize = singleUnitPackageSize;
	}

	findSelectedReferencePrice(): ReferencePrice | null {
		return this.referencePrices.find((price) => price.calculatedPrice.selected) ?? null;
	}
}
